import React, { useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Button, message } from "antd";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useDepartmentDetail } from "Hooks/AdminHooks/Organization/useDepartmentDetail";

export const CreateJobTile = () => {
  const {
    createJobTitle,
    formData,
    setFormData,
    fetchJobTitle,
    jobTitle,
    loadingEditJob,
    updateJobTitle,
  } = useDepartmentDetail();
  const { departmentId, jobTitleId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (jobTitleId) {
      fetchJobTitle(jobTitleId);
    }
  }, [jobTitleId]);

  useEffect(() => {
    if (jobTitle) {
      setFormData({
        name: jobTitle.name,
        description: jobTitle.description,
        departmentId: jobTitle.department.id,
      });
    }
  }, [jobTitle]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    

    try {
      if (jobTitleId) {
        const payload = {
          id: parseInt(jobTitleId),
          name: formData.name,
          description: formData.description,
        };
        const result = await updateJobTitle(payload);
        if (result && result.name) {
          message.success("Job Title Updated successfully");
          setFormData({ name: "", description: "", departmentId: parseInt(departmentId) });
          setTimeout(() => {
            navigate("/organization/job-titles", {
  state: { departmentId: jobTitle.department?.id },
});
          }, 2500);
        }
      } else {

        const payload = {
      name: formData.name,
      description: formData.description,
      departmentId: parseInt(departmentId),
    };
        const result = await createJobTitle(payload);
        if (result && result.name) {
          message.success("Job Title created successfully");
          setFormData({ name: "", description: "", departmentId: parseInt(departmentId) });
          setTimeout(() => {
            if (location.state?.returnTo === "department-detail") {
        navigate(`/department-detail/${location.state.departmentId}`);
      } else {
        navigate("/organization/job-titles",
           { state: { departmentId: location.state?.departmentId  || departmentId} });
      }
          }, 2500);
        }
      }
    } catch (error) {
      console.error(error);
      message.error(error.response?.data?.details || error.message);
    }
  };
  if(loadingEditJob){
    <div>Loading...</div>
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ padding: "24px", maxWidth: "600px", margin: "0 auto" }}>
        {/* Page Heading */}
        <h2 className="fw-bold mb-4">{jobTitleId ? "Update Job Title" : "Create Job Title"}</h2>

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label mb-1">Name</label>
            <input
              className="form-control"
              type="text"
              value={formData.name}
              placeholder="Please Enter Job Title"
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            />
          </div>

          <div className="mb-3">
            <label className="form-label mb-1">Description</label>
            <textarea
              className="form-control"
              rows="3"
              value={formData.description}
              placeholder="Please Enter Description"
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
            />
          </div>

          {/* Buttons */}
          <div className="d-flex justify-content-end gap-2 mt-4">
            <Button size="large" onClick={() => navigate(-1)}>
              Cancel
            </Button>
            <Button  size="large" className="btn-primary" htmlType="submit">
              {jobTitleId ? " Update" : "Save"}
            </Button>
          </div>
        </form>
      </div>
    </DashboardLayout>
  );
};

export default CreateJobTile;
